import React, { useState } from 'react';
import styles from './BillingAccounting.module.css';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import TabSelector from '../../components/TabSelector/TabSelector';
import HeadingBelowNumber from '../../components/HeadingBelowNumber/HeadingBelowNumber';
import { HiMiniDocumentText } from 'react-icons/hi2';

// import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { NavLink } from 'react-router';
import CustomPieChart from '../../components/CustomPieChart/CustomPieChart.jsx';

export const BillingAccounting = () => {
  const [activeTab, setActiveTab] = useState('Center');

  const feeData = {
    paidFee: 253666,
    unpaidFee: 253666,
    totalFee: 263666,
    paidStudents: 7,
    unpaidStudents: 3,
  };

  const tabOptions = [{ label: 'Center' }, { label: 'Room' }];
  const statCards = [
    {
      heading: 'Total paid Fee',
      value: `${feeData.paidFee}`,
      bgColor: 'rgba(from var(--Warning_Color) r g b / 0.3)',
      textColor: 'Warning_Color',
    },
    {
      heading: 'Total unpaid Fee',
      value: `${feeData.unpaidFee}`,
      bgColor: 'rgba(from var(--Primary_Color) r g b / 0.3)',
      textColor: 'Primary_Color',
    },
    {
      heading: 'Total Fee',
      value: `${feeData.totalFee}`,
      bgColor: 'rgba(from var(--Error_Color) r g b / 0.3)',
      textColor: 'Error_Color',
    },
    {
      heading: 'Total paid Students',
      value: `${feeData.paidStudents}`,
      bgColor: 'rgba(from var(--Info_Color) r g b / 0.3)',
      textColor: 'Info_Color',
    },
    {
      heading: 'Total unpaid Students',
      value: `${feeData.unpaidStudents}`,
      bgColor: 'rgba(from var( --Warning_Color) r g b / 0.3)',
      textColor: 'Warning_Color',
    },
  ];

  const pieData = [
    { name: 'Total Fee', value: feeData.totalFee, color: '--Error_Color' },
    { name: 'Unpaid Fee', value: feeData.unpaidFee, color: '--Primary_Color' },
    { name: 'Paid Fee', value: feeData.paidFee, color: '--Success_Color' },
  ];

  const studentTotal = feeData.paidStudents + feeData.unpaidStudents;

  const data = [
    { value: 2636663, label: 'INR 2636663' },
    { value: 253666, label: 'INR 253666' },
    { value: 253666, label: 'INR 253666' },
  ];

  const colors = ['#E6A9A9', '#A9B4E6', '#A9E6B2'];

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiMiniDocumentText size={22} color="var(--Primary_Color)" />}
          heading="Billing & Accounting"
        />
        <div className={styles.headerActions}>
          <TabSelector
            options={tabOptions}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
          />
          <NavLink className={styles.viewAll} to={'accounting/dashboard'}>
            View All
          </NavLink>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.cardsRow}>
          {statCards.map((card, index) => (
            <HeadingBelowNumber
              key={index}
              heading={card.heading}
              number={card.value}
              bgColor={card.bgColor}
              textColor={card.textColor}
            />
          ))}
        </div>

        <div className={styles.graphSection}>
          <div className={styles.graphSectionContainer}>
            <div className={styles.barSection}>
              <p className={styles.label}>Fee</p>
              <div className={styles.feeBar}>
                <div
                  className={styles.barPaid}
                  style={{
                    width: `${
                      (feeData.paidFee /
                        (feeData.paidFee + feeData.unpaidFee)) *
                      100
                    }%`,
                  }}
                />
                <div
                  className={styles.barUnpaid}
                  style={{
                    width: `${
                      (feeData.unpaidFee /
                        (feeData.paidFee + feeData.unpaidFee)) *
                      100
                    }%`,
                  }}
                />
              </div>
              <div className={styles.barLabels}>
                <span>INR {feeData.paidFee}</span>
                <span>INR {feeData.unpaidFee}</span>
              </div>

              <p className={styles.label}>Students</p>
              <div className={styles.barTrack}>
                <div
                  className={styles.barPaidStudents}
                  style={{
                    width: `${(feeData.paidStudents / studentTotal) * 100}%`,
                  }}
                />
                <div
                  className={styles.barUnpaidStudents}
                  style={{
                    width: `${(feeData.unpaidStudents / studentTotal) * 100}%`,
                  }}
                />
              </div>
              <div className={styles.barLabels}>
                <span>{feeData.paidStudents}</span>
                <span>{feeData.unpaidStudents}</span>
              </div>
            </div>
          </div>

          <div className={styles.divider}></div>
          <CustomPieChart data={data} colors={colors} />
        </div>

        <div className={styles.legend}>
          <div>
            <span style={{ backgroundColor: 'var(--Error_Color)' }} /> Total Fee
          </div>
          <div>
            <span style={{ backgroundColor: 'var(--Primary_Color)' }} /> Unpaid
            Fee
          </div>
          <div>
            <span style={{ backgroundColor: 'var(--Success_Color)' }} /> Paid
            Fee
          </div>
          <div>
            <span style={{ backgroundColor: 'var(--Warning_Color)' }} /> Paid
            Students
          </div>
          <div>
            <span style={{ backgroundColor: 'var(--Warning_Color)' }} /> Unpaid
            Students
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingAccounting;
